import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  template: '',
})
export class RedirectAdminComponent implements OnInit {
  constructor() { } ngOnInit() {
    window.location.href = environment.adminUrl;
  }
}
